import React, { useState } from 'react'
import Cookie from 'cookie-universal'
import { AUTH_TYPE, ONE_DAY } from '@mc/constants'
import { Button, ButtonKinds, IconSocialGoogleActive } from '@mc/design-system'
import { isInAppBrowser } from '@mc/devices'
import { setFireEmailCaptureCookie } from '@mc/email-capture'
import { useTranslation, withI18nContext } from '@mc/i18n'
import { i18nInstance } from '../../../i18n/i18nInstance'
import { SocialButtonProps } from '../types'

const GoogleButtonComponent = ({
  kind = ButtonKinds.TERTIARY,
  className = '',
  text = '',
  fullWidth = false,
  onClick = () => {},
  captureMethod,
  userAgent = '',
}: SocialButtonProps) => {
  const [loading, setLoading] = useState(false)
  const { t } = useTranslation('@mc/authentication')
  const action = text || t('thirdParty.google')

  // see isInAppBrowser to understand why
  if (isInAppBrowser(userAgent)) return null

  const onClickButton = () => {
    setLoading(true)
    const query = new URLSearchParams(window?.location.search)
    const nextPage = query?.get('next_page')

    if (nextPage) {
      const cookies = Cookie()

      cookies.set('last_mc_url', nextPage, {
        encode: (e) => e,
        maxAge: ONE_DAY,
      })
    }

    onClick({ track: { action } })
    setLoading(false)
    if (captureMethod) {
      setFireEmailCaptureCookie({
        authType: AUTH_TYPE.GOOGLE,
        captureMethod,
      })
    }
    window.location.href = '/auth/google_oauth2/'
  }

  return (
    <Button
      kind={kind}
      onClick={onClickButton}
      className={className}
      loading={loading}
      fullWidth={fullWidth}
    >
      <IconSocialGoogleActive className='mc-mr-2' />
      {action}
    </Button>
  )
}

export const GoogleButton = withI18nContext(i18nInstance)(GoogleButtonComponent)
